import React from 'react'
import crm from "../../assets/products/crm.png"
import retail from "../../assets/products/retail.png"
import expense from "../../assets/products/expense.png"
import billing from "../../assets/products/bill.png"
import payroll from "../../assets/products/payroll.png"
import ecommerce from "../../assets/products/ecom.png"





import { Link } from 'react-router-dom'

const Products = () => {
  return (
    <>
      <div className="bg-blue-800 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-3">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl mt-12 font-semibold font-mfont text-mwhite sm:text-4xl">
              All the softwares needed for your Business
            </h2>
          </div>
        </div>
      </div>


      <div className="bg-mgray w-full flex flex-col gap-5 px-3 md:px-16 lg:px-0 md:flex-row">


        <aside className="hidden w-80 py-4 md:block relative space-y-8 bg-white border-e border-gray-200    ">
          <div className="sticky top-12 flex flex-col gap-3 ">
            <h5 className=" text-2xl font-mfont justify-center  text-center font-semibold text-mblack dark:text-blue-200">Featured Apps</h5>
            <h3 className='flex flex-col gap-5 px-[50px] text-xl font-bold font-mfont text-mblack'>Apps</h3>

            <a className="block  px-[60px] text-lg font-semibold text-mblack
             hover:border-blue-400   hover:text-blue-600 active:text-blue-600
                hs-scrollspy-active:font-medium hs-scrollspy-active:text-blue-600 
               active" href="#Sales">• Sales</a>

            <a className="block px-[60px] text-lg font-semibold text-mblack
             hover:border-blue-400   hover:text-blue-600 active:text-blue-600
                hs-scrollspy-active:font-medium hs-scrollspy-active:text-blue-600 
               active" href="#humanresource">• Resources</a>

            <a className="block   px-[60px] text-lg font-semibold text-mblack
             hover:border-blue-400   hover:text-blue-600 active:text-blue-600
                hs-scrollspy-active:font-medium hs-scrollspy-active:text-blue-600 
               active" href="#Finance">• Finance</a>

            <a className="block   px-[60px] text-lg font-semibold text-mblack
             hover:border-blue-400   hover:text-blue-600 active:text-blue-600
                hs-scrollspy-active:font-medium hs-scrollspy-active:text-blue-600 
               active" href="#marketing">• Marketing</a>
            {/* <a href='/makingminds/workspace'
              target='_blank'
              rel="noreferrer"
              className='flex flex-col gap-5 px-[50px] text-xl font-bold font-mfont text-mblack hover:text-blue-600 active:text-blue-600'>Workspace</a> */}


          </div>
        </aside>

        <main className=" !w-full py-1 bg-mgray">
          <div className="p-2 md:p-4">
            <h5 className=" text-2xl font-mfont justify-center text-center font-semibold text-black dark:text-blue-200">Featured Apps</h5>

            <div className="mt-1">
              <div id="scrollspy" className="space-y-0 md:space-y-2">

                <div id="Sales" className="scroll-mt-24 ">
                  <div className="container lg:px-5 px-0 lg:py-10 py-5 mx-auto">
                    <div className="flex flex-col px-5 text-left w-full mb-2">
                      <h6 className="text-left text-2xl lg:text-3xl mb-2 lg:mb-5 font-medium text-mblack font-mfont">
                        Sales
                      </h6>
                      <p className="text-left text-xl  font-medium font-mfont text-black ">Help your sales team be more productive with tools.
                      </p>
                    </div>
                    <div className="flex flex-wrap ">
                      <div className="lg:w-1/3 md:w-1/2 p-4 w-full">
                        <div className="flex rounded-lg  bg-white hover:border-blue-700 
                        transform transition duration-500 hover:scale-110 border p-8 flex-col">
                          <div className="flex justify-left mb-3">
                            <img
                              className="w-12"
                              src={crm}
                              alt="crm" />
                          </div>
                          <h2 className="text-mblack  text-left text-xl mb-5 font-medium">CRM</h2>
                          <p className="text-mblack  text-left text-md mb-5 font-medium">Comprehensive CRM platform for Customers.</p>
                          <div className="flex-grow text-left">
                            <Link
                              to="/"
                              className="relative hover:text-blue-600 text-lg font-mfont flex font-semibold text-mblack "
                            >
                              Try now
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M10 7L15 12L10 17"
                                  stroke="#000"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="lg:w-1/3 md:w-1/2 p-4 w-full">
                        <div className="flex rounded-lg  bg-white hover:border-blue-700 
                        transform transition duration-500 hover:scale-110 border p-8 flex-col">
                          <div className="flex justify-left mb-3">
                            <img
                              className="w-12"
                              src={retail}
                              alt="retail" />
                          </div>
                          <h2 className="text-mblack  text-left text-xl mb-5 font-medium">Retail</h2>
                          <p className="text-mblack  text-left text-md mb-5 font-medium">Manage your retail and supply chain effortlessly.</p>
                          <div className="flex-grow text-left">
                            <Link
                              to="/"
                              className="relative hover:text-blue-600 text-lg font-mfont flex font-semibold text-mblack "
                            >
                              Try now
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M10 7L15 12L10 17"
                                  stroke="#000"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="humanresource" className="scroll-mt-24 ">
                  <div className="container lg:px-5 px-0 lg:py-10 py-5 mx-auto">
                    <div className="flex flex-col px-5 text-left w-full mb-2">
                      <h6 className="text-left text-2xl lg:text-3xl mb-2 lg:mb-5 font-medium text-mblack font-mfont">
                        Human Resources
                      </h6>
                      <p className="text-left text-xl  font-medium font-mfont text-black ">
                        Hire new employees, run training sessions, and manage all HR operations with ease.
                      </p>
                    </div>
                    <div className="flex flex-wrap ">
                      <div className="lg:w-1/3 md:w-1/2 p-4 w-full">
                        <div className="flex rounded-lg  bg-white hover:border-blue-700 
                        transform transition duration-500 hover:scale-110 border p-8 flex-col">
                          <div className="flex justify-left mb-3">
                            <img
                              className="w-12"
                              src={expense}
                              alt="expense" />
                          </div>
                          <h2 className="text-mblack  text-left text-xl mb-5 font-medium">Expense</h2>
                          <p className="text-mblack  text-left text-md mb-5 font-medium">
                            Simplified Business Expense tracking software Platform.</p>
                          <div className="flex-grow text-left">
                            <a
                              href="https://www.expensetracker.fun/"
                              target='_blank'
                              rel="noreferrer"
                              className="relative hover:text-blue-600 text-lg font-mfont flex font-semibold text-mblack "
                            >
                              Try now
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M10 7L15 12L10 17"
                                  stroke="#000"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="Finance" className="scroll-mt-24 min-h-[25rem]">
                  <div className="container lg:px-5 px-0 lg:py-10 py-5 mx-auto">
                    <div className="flex flex-col px-5 text-left w-full mb-2">
                      <h6 className="text-left text-2xl lg:text-3xl mb-2 lg:mb-5 font-medium text-mblack font-mfont">
                        Finance
                      </h6>
                      <p className="text-left text-xl  font-medium font-mfont text-black ">
                        Keep a tab on your expenses and manage your back office operations smoothly.
                      </p>
                    </div>
                    <div className="flex flex-wrap ">
                      <div className="lg:w-1/3 md:w-1/2 p-4 w-full">
                        <div className="flex rounded-lg  bg-white hover:border-blue-700 
                        transform transition duration-500 hover:scale-110 border p-8 flex-col">
                          <div className="flex justify-left mb-3">
                            <img
                              className="w-12"
                              src={billing}
                              alt="billing" />
                          </div>
                          <h2 className="text-mblack  text-left text-xl mb-5 font-medium">Billing</h2>
                          <p className="text-mblack  text-left text-md mb-5 font-medium">
                            Stock management and inventory contro software.</p>
                          <div className="flex-grow text-left">
                            <a
                              href="https://www.makingmindsbilling.site"
                              target='_blank'
                              rel="noreferrer"
                              className="relative hover:text-blue-600 text-lg font-mfont flex font-semibold text-mblack "
                            >
                              Try now
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M10 7L15 12L10 17"
                                  stroke="#000"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="lg:w-1/3 md:w-1/2 p-4 w-full">
                        <div className="flex rounded-lg  bg-white hover:border-blue-700 
                        transform transition duration-500 hover:scale-110 border p-8 flex-col">
                          <div className="flex justify-left mb-3">
                            <img
                              className="w-12"
                              src={payroll}
                              alt="payroll" />
                          </div>
                          <h2 className="text-mblack  text-left text-xl mb-5 font-medium">Payroll</h2>
                          <p className="text-mblack  text-left text-md mb-5 font-medium">
                            Simple, free payroll for your growing business.</p>
                          <div className="flex-grow text-left">
                            <a
                              href="/"
                              target='_blank'
                              rel="noreferrer"
                              className="relative hover:text-blue-600 text-lg font-mfont flex font-semibold text-mblack "
                            >
                              Try now
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M10 7L15 12L10 17"
                                  stroke="#000"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div id="marketing" className="scroll-mt-24 min-h-[25rem]">
                  <div className="container lg:px-5 px-0 lg:py-10 py-5 mx-auto">
                    <div className="flex flex-col px-5 text-left w-full mb-2">
                      <h6 className="text-left text-2xl lg:text-3xl mb-2 lg:mb-5 font-medium text-mblack font-mfont">
                        Marketing
                      </h6>
                      <p className="text-left text-xl  font-medium font-mfont text-black ">
                        Engage with prospects using multi-channel marketing tools that help you personalize experiences at scale.
                      </p>
                    </div>
                    <div className="flex flex-wrap ">
                      <div className="lg:w-1/3 md:w-1/2 p-4 w-full">
                        <div className="flex rounded-lg  bg-white hover:border-blue-700 
                        transform transition duration-500 hover:scale-110 border p-8 flex-col">
                          <div className="flex justify-left mb-3">
                            <img
                              className="w-12"
                              src={ecommerce}
                              alt="ecommerce" />
                          </div>
                          <h2 className="text-mblack  text-left text-xl mb-5 font-medium">Commerce</h2>
                          <p className="text-mblack  text-left text-md mb-5 font-medium">
                            eCommerce platform to manage and market your online store.</p>
                          <div className="flex-grow text-left">
                            <a
                              href="https://makingmindsecom.vercel.app/"
                              target='_blank'
                              rel="noreferrer"
                              className="relative hover:text-blue-600 text-lg font-mfont flex font-semibold text-mblack "
                            >
                              Try now
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M10 7L15 12L10 17"
                                  stroke="#000"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>


              </div>

            </div>

          </div>
        </main>
        {/* </section> */}
      </div>





    </>
  )
}

export default Products


